import classNames from 'classnames'
import React, { ReactNode } from 'react'

import { Skeleton } from '@ui/v2/Skeleton'

import { Box } from '@shared/components/Box/Box'

import { EmptyPortfolioState } from './EmptyPortfolioState'

import styles from './CardTradingView.module.scss'

const DEFAULT_INITIAL_SKELETONS = 3
const DEFAULT_LOADING_MORE_SKELETONS = 1

interface TradeCardListProps {
  children: ReactNode
  isLoading?: boolean
  isLoadingMore?: boolean
  isEmpty: boolean
  hasActiveFilters?: boolean
  className?: string
  initialSkeletonCount?: number
  loadingMoreSkeletonCount?: number
}

const TradeCardSkeleton = () => {
  return (
    <Box
      flex
      direction='column'
      gap='x12'
      px='x16'
      py='x12'
      radius='x16'
      className={classNames(styles.outlined, styles.tradeItem, styles.pendingRow)}
    >
      <Skeleton variant='rect' />
      <Skeleton />
    </Box>
  )
}

export const TradeCardList: React.FC<TradeCardListProps> = ({
  children,
  isLoading = false,
  isLoadingMore = false,
  isEmpty,
  hasActiveFilters,
  className,
  initialSkeletonCount = DEFAULT_INITIAL_SKELETONS,
  loadingMoreSkeletonCount = DEFAULT_LOADING_MORE_SKELETONS,
}) => {
  if (!isLoading && isEmpty) {
    return <EmptyPortfolioState hasActiveFilters={hasActiveFilters} />
  }

  const shouldShowInitialSkeletons = isLoading && isEmpty

  return (
    <Box flex direction='column' gap='x12' className={className}>
      {children}
      {shouldShowInitialSkeletons &&
        Array.from({ length: initialSkeletonCount }).map((_, index) => (
          <TradeCardSkeleton key={`trade-card-skeleton-${index}`} />
        ))}

      {isLoadingMore &&
        Array.from({ length: loadingMoreSkeletonCount }).map((_, index) => (
          <TradeCardSkeleton key={`trade-card-loading-more-${index}`} />
        ))}
    </Box>
  )
}

export default TradeCardList
